// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ScissorOutlinedSvg from "@ant-design/icons-svg/es/asn/ScissorOutlined";
import AntdIcon from '../components/AntdIcon';

var ScissorOutlined = function ScissorOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ScissorOutlinedSvg
  }));
};

ScissorOutlined.displayName = 'ScissorOutlined';
export default React.forwardRef(ScissorOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ScissorOutlined.js
// module id = 1761
// module chunks = 0